<template>
  <div>
    <a-modal
      ref="createModal"
      title="完工-组装中心"
      :width="1200"
      :visible="visible"
      :maskClosable="false"
      @cancel="close"
      :footer="null"
    >
      <a-form layout="inline" :labelCol="{ style: { width: '65px' } }">
        <a-row :gutter="6">
          <a-col :md="6" :sm="24">
            <a-form-item label="标签码">
              <a-select v-model="queryParams.serialNumber">
                <a-select-option v-for="(item) in serialNumberList" :key="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="包装明细">
              <a-select v-model="queryParams.packageList">
                <a-select-option v-for="(item) in packageList" :key="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="包件序号">
              <a-select v-model="queryParams.packageNumber">
                <a-select-option v-for="(item) in packageNumberList" :key="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="检验结果">
              <a-select v-model="queryParams.qualityStatus">
                <a-select-option v-for="(item) in qualityStatusNameList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="6" v-show="advanced">
          <a-col :md="6" :sm="24">
            <a-form-item label="报工标识">
              <a-select v-model="queryParams.reportingFlag">
                <a-select-option v-for="(item) in reportingFlagList" :key="item.key">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="托盘码">
              <a-select v-model="queryParams.palletNo">
                <a-select-option v-for="(item) in palletNoList" :key="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="完工标识">
              <a-select v-model="queryParams.storageFlag">
                <a-select-option v-for="(item) in storageFlagList" :key="item.key">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="批次号">
              <a-select v-model="queryParams.lotNumber">
                <a-select-option v-for="(item) in lotNumberList" :key="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div class="table-page-operator-wrapper mt10">
        <a-button :loading="isSaveBtnLoading" :disabled="selectedRows.length === 0" @click="confirm()" type="primary">保存</a-button>
        <div>
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button @click="reset(true)">重置</a-button>
          <a @click="toggleAdvanced" class="ml8">
            {{ advanced ? '收起' : '展开' }}
            <a-icon :type="advanced ? 'up' : 'down'"/>
          </a>
        </div>
      </div>
      <a-table
        ref="modalTable"
        :columns="columns"
        :data-source="tableList"
        :loading="pageParams.tableLoading"
        :pagination="false"
        row-key="wipSerialId"
        :row-selection="rowSelection"
        :scroll="{ x: 800, y: 400 }"
      >
        <span slot="wgzkTitle">
          <i class="toRequired">*</i>完工子库
        </span>
        <span slot="wghwTitle">
          <i class="toRequired">*</i>完工货位
        </span>
        <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
          <div :key="item.dataIndex">
            <span v-if="item.type === 'select'">
              <global-select
                :value.sync="record[item.dataIndex]"
                :selectType="item.selectType ? item.selectType : 'select'"
                :focusGet="item.focusGet ? item.focusGet : false"
                :requestApi="item.requestApi"
                :selectData="setArray(item.dataList)"
                :selectItem="{ value: item.value, label: item.label }"
                :searchParam="item.searchParam ? item.searchParam : ''"
                :setParams="item.setParams ? setParamsHandle(record, item.dataIndex) : null"
                :sourseField="item.sourseField ? item.sourseField : ''"
                :allowClear="false"
                :assembleLabel="item.assembleLabel ? item.assembleLabel : false"
              />
            </span>
            <span v-else-if="item.type === 'input'">
              <a-input v-model="record[item.dataIndex]" />
            </span>
            <span v-else>{{ text }}</span>
          </div>
        </template>

      </a-table>
      <!-- 底部分页按钮 -->
      <Page ref="page" :pageParams.sync="pageParams" @getList="getList" />
    </a-modal>
  </div>
</template>

<script>
import { apiMesDispatchCompletionAssemblyCenter, apiMesDispatchCompletionAssemblyCenterPageBox } from '@/api/mes/workOrderManage/workOrderSent'
export default {
  props: {},
  data () {
    return {
      pageParams: {
        automatic: false,
        pageUrl: '/mes/mesDispatch/completionAssemblyCenterPage',
        tableLoading: false
      },
      visible: false,
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        wipEntityId: "",
        serialNumber: "",
        packageList: "",
        packageNumber: "",
        qualityStatus: "",
        reportingFlag: "",
        palletNo: "",
        storageFlag: "",
        lotNumber: ""
      },
      columns: [
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          width: 150
        },
        {
          title: '成品',
          dataIndex: 'assembly',
          width: 150
        },
        {
          title: '规格描述',
          dataIndex: 'description',
          width: 150,
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'primaryUomCode',
          width: 80
        },
        {
          title: '标签码',
          dataIndex: 'serialNumber',
          width: 120
        },
        {
          // title: '完工子库',
          dataIndex: 'sublibrary',
          scopedSlots: { customRender: 'sublibrary', title: "wgzkTitle" },
          width: 150,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "warehouseCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoSublibraryBox',
          value: 'realValue',
          label: 'label'
        },
        {
          // title: '完工货位',
          dataIndex: 'location',
          scopedSlots: { customRender: 'location', title: "wghwTitle" },
          width: 150,
          type: "select",
          selectType: "selectSearch",
          focusGet: true,
          searchParam: "locationCode",
          setParams: true,
          requestApi: '/inv/invCallRequestLines/intoGoodsAllocationBox',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '检验方式',
          dataIndex: 'inspectModeName',
          width: 100
        },
        {
          title: '检验结果',
          dataIndex: 'qualityStatusName',
          width: 150
        },
        {
          title: '托盘码',
          dataIndex: 'palletNo',
          scopedSlots: { customRender: 'palletNo' },
          width: 150,
          type: "input"
        },
        {
          title: '包件序号',
          dataIndex: 'packageNumber',
          width: 150
        },
        {
          title: '包装明细',
          dataIndex: 'packageList',
          width: 150
        },
        {
          title: '批次号',
          dataIndex: 'lotNumber',
          width: 180
        },
        {
          title: '仓库',
          dataIndex: 'destination',
          width: 150
        },
        {
          title: '报工标识',
          dataIndex: 'reportingFlag',
          width: 150
        },
        {
          title: '完工标识',
          dataIndex: 'storageFlag',
          width: 150
        }
      ],
      tableList: [],
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      serialNumberList: [], // 标签码
      packageList: [], // 包装明细
      packageNumberList: [], // 包件序号
      palletNoList: [], // 托盘码
      lotNumberList: [], // 批次号
      qualityStatusNameList: [], // 检验结果
      reportingFlagList: [
        {
          key: "Y",
          label: "已报工"
        },
        {
          key: "N",
          label: "未报工"
        }
      ], // 报工标识
      storageFlagList: [
        {
          key: "Y",
          label: "已完工"
        },
        {
          key: "N",
          label: "未完工"
        }
      ], // 完工标识
      desOrganizationCode: "",
      isSaveBtnLoading: false // 保存按钮loading
    }
  },
  created () {
    this.getLookupList('QUALITY_STATUS', 'qualityStatusNameList')
  },
  methods: {
    // 下拉框数据
    getFounderBox () {
      apiMesDispatchCompletionAssemblyCenterPageBox(this.wipEntityId).then(res => {
        if (res.code === 200 && res.data) {
          this.serialNumberList = res.data.serialNumberList || []
          this.packageList = res.data.packageList || []
          this.packageNumberList = res.data.packageNumberList || []
          this.palletNoList = res.data.palletNoList || []
          this.lotNumberList = res.data.lotNumberList || []
        }
      })
    },
    show (val) {
      this.wipEntityId = val.id
      this.queryParams.wipEntityId = val.id
      this.visible = true
      this.desOrganizationCode = val.desOrganizationCode
      this.$nextTick(() => {
        this.$refs.page.getFirstPage(this.queryParams)
      })
      this.getFounderBox()
    },
    // 保存
    confirm () {
      let flag = false
      const arr = []
      for (let i = 0; i < this.selectedRows.length; i++) {
        if (!this.selectedRows[i].sublibrary || !this.selectedRows[i].location) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }

        const obj = {
          wipEntityId: this.wipEntityId,
          wipSerialId: this.selectedRows[i].wipSerialId,
          sublibrary: this.selectedRows[i].sublibrary,
          location: this.selectedRows[i].location,
          palletNo: this.selectedRows[i].palletNo
        }
        arr.push(obj)
      }
      if (flag) {
        return false
      }
      this.isSaveBtnLoading = true
      apiMesDispatchCompletionAssemblyCenter(arr).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          // 关闭本组件
          this.visible = false
        } else {
          this.$message.error(response.msg)
        }
        this.isSaveBtnLoading = false
      }).catch(() => {
        this.isSaveBtnLoading = false
      })
    },
    handleSearch () {
      this.$refs.page.getFirstPage(this.queryParams)
    },
    reset (flag) {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        wipEntityId: "",
        serialNumber: "",
        packageList: "",
        packageNumber: "",
        qualityStatus: "",
        reportingFlag: "",
        palletNo: "",
        storageFlag: "",
        lotNumber: ""
      }
      this.queryParams.wipEntityId = this.wipEntityId
      flag && this.handleSearch()
    },
    /** 查询列表 */
    getList (data) {
      this.tableList = data.rows
    },
    setParamsHandle (record, dataIndex) {
      if (dataIndex === "sublibrary") {
        return { organizationCode: this.desOrganizationCode }
      }
      if (dataIndex === "location") {
        return { subinventoryCode: record.sublibrary }
      }
    },
    setArray (arr) {
      return this[arr]
    },
    close () {
      this.visible = false
      this.reset()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.mt10{
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
/deep/.ant-modal-body{
  // height: 600px;
  overflow-y: scroll;
}
/deep/.ant-select{
  width: 140px;
}
</style>
